import { render, staticRenderFns } from "./SalaryAndPay.vue?vue&type=template&id=40ae21ce&scoped=true"
import script from "./SalaryAndPay.vue?vue&type=script&lang=js"
export * from "./SalaryAndPay.vue?vue&type=script&lang=js"
import style0 from "./SalaryAndPay.vue?vue&type=style&index=0&id=40ae21ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae21ce",
  null
  
)

export default component.exports